const SELECTORS = Selectors({
  map: 'arrival-map',
  mapData: 'arrival-map-data'
})

const $map = document.getElementById(SELECTORS.map)
const $mapData = document.getElementById(SELECTORS.mapData)

const fn = {
  init: () => {
    fn.setupMap()
  },

  setupMap: () => {
    const am4core = window.am4core
    const am4themes_animated = window.am4themes_animated
    const am4maps = window.am4maps
    const am4geodata_worldLow = window.am4geodata_worldLow

    am4core.ready(function() {

      am4core.useTheme(am4themes_animated)

      const chart = am4core.create('arrival-map', am4maps.MapChart)

      chart.chartContainer.wheelable = false
      chart.zoomControl = new am4maps.ZoomControl()
      chart.zoomControl.width = 50

      const mapData = JSON.parse($mapData.textContent)

      // Set map definition
      chart.geodata = am4geodata_worldLow

      // Set projection
      chart.projection = new am4maps.projections.Miller()

      // Create map polygon series
      const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries())
      polygonSeries.exclude = ['AQ']
      polygonSeries.useGeodata = true
      polygonSeries.nonScalingStroke = true
      polygonSeries.strokeWidth = 0.5
      polygonSeries.fillOpacity = 0.6
      polygonSeries.mapPolygons.template.polygon.fill = am4core.color('#ffffff')
      polygonSeries.mapPolygons.template.polygon.fillOpacity = 0.6
      polygonSeries.mapPolygons.template.polygon.stroke = am4core.color('#005161')

      const imageSeries = chart.series.push(new am4maps.MapImageSeries())
      imageSeries.data = mapData
      imageSeries.dataFields.value = 'value'

      const imageTemplate = imageSeries.mapImages.template
      imageTemplate.propertyFields.latitude = 'latitude'
      imageTemplate.propertyFields.longitude = 'longitude'
      imageTemplate.nonScaling = true

      const circle = imageTemplate.createChild(am4core.Circle)
      circle.fillOpacity = 0.7
      circle.fill = am4core.color('#fde038')
      circle.strokeWidth = 1
      circle.stroke = am4core.color('#ffffff'),
      circle.tooltipText = '{name}: [bold]{value}[/]'

      imageSeries.heatRules.push({
        'target': circle,
        'property': 'radius',
        'min': 4,
        'max': 30,
        'dataField': 'value'
      })

    })
  }
}

export default {
  can: () => $map,
  run: fn.init
}
